<script>

  export default {
    name: "ChannelsSectionBox",
    props: {
      data: {
        type: Object,
      },
    },
    computed: {
      getBgGradient() {
        let gradient = ''

        if (this.data.bg_color === 'orange') {
          gradient = 'rgba(241, 111, 33, 0.65) 0%, #C74B1B 100%'
        }

        if (this.data.bg_color === 'green') {
          gradient = 'rgba(12, 127, 64, 0.65) 0%, #0A6834 100%'
        }

        if (this.data.bg_color === 'blue') {
          gradient = 'rgba(25, 73, 151, 0.65) 0%, #00307E 100%'
        }

        if (this.data.bg_color === 'red') {
          gradient = 'rgba(164, 9, 50, 0.65) 0%, #A40932 100%'
        }

        if (this.data.bg_color === 'yellow') {
          gradient = 'rgba(153, 117, 0, 0.6) 0%, #997500 50%'
        }

        if (this.data.bg_color === 'purple') {
          gradient = 'rgba(58, 48, 98, 0.6) 0%, #3A3062 50%'
        }

        return gradient
      },
      getBackgroundImage() {
        return `background: linear-gradient(180deg, ${this.getBgGradient}), url('${this.data.bg_image}'), lightgray -145.833px -39.232px / 203.432% 100% no-repeat;`
      }
    }
  }
</script>

<template>
    <article class="px-1 pb-1 pt-6" v-bind:style="getBackgroundImage">
        <div class="d-flex align-items-center mb-1">
            <img :src="data.image" class="img-fluid me-1" :alt="data.name" />
            <div>
                <h3 class="text-white">{{ data.name }}</h3>
                <small>{{ data.category }}</small>
            </div>
        </div>

        <p class="beta text-white mb-1 channelbox-min-height">{{ data.description }}</p>
        <a v-if="data.link"
            target="_blank"
            :href="data.link.slug ? `/${data.link.slug}` : data.link.external"
            class="fw-semibold d-flex justify-content-between transition"
            >{{ data.link.label }}
            <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <path
                    d="M5.5 15L15.5 5M15.5 5H8.83333M15.5 5V11.6667"
                    stroke="white"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </a>
        <a v-else
            target="_blank"
            href=""
            class="fw-semibold d-flex justify-content-between transition"
            style="visibility: hidden"
            >Show channel
            <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <path
                    d="M5.5 15L15.5 5M15.5 5H8.83333M15.5 5V11.6667"
                    stroke="white"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </a>
    </article>
</template>



<style lang="scss" scoped>
article {
    border-radius: 1rem;
    background-size: 130% !important;
}
.channelbox-min-height{
  min-height: 140px;
  max-height: 168px;
  overflow: auto;
}
img {
    width: 3.1rem;
}

h3 {
    font-size: 0.8rem;
    font-weight: var(--font-weight-semibold);
}

small {
    color: rgba(255, 255, 255, 0.7);
}

p {
    line-height: 1.75rem !important;
    letter-spacing: -0.6px;
}

a {
    display: block;
    background: rgba(255, 255, 255, 0.2);
    color: var(--global-color-white);
    padding: 0.625rem 1rem;
    font-size: 0.8rem;
    border-radius: 0.5rem;

    &:hover {
        background: rgba(255, 255, 255, 0.4);
    }
}
</style>
